import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/messageCenter/messageHome/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/messageHome'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/messageCenter/messageDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/messageDetail'
  }
]
